/**
 * Appels API pour l'administration des utilisateurs, squads et practices.
 */

import api from "./axiosConfig";

// --- Utilisateurs ---

export async function getUsers() {
  const response = await api.get("/admin/users");
  return response.data;
}

export async function createUser(data) {
  const response = await api.post("/admin/users", data);
  return response.data;
}

export async function updateUser(id, data) {
  const response = await api.put(`/admin/users/${id}`, data);
  return response.data;
}

export async function deleteUser(id) {
  await api.delete(`/admin/users/${id}`);
}

export async function resetPassword(id, newPassword) {
  const response = await api.put(`/admin/users/${id}/reset-password`, {
    new_password: newPassword,
  });
  return response.data;
}

// --- Squads ---

export async function getSquads() {
  const response = await api.get("/admin/squads");
  return response.data;
}

export async function createSquad(data) {
  const response = await api.post("/admin/squads", data);
  return response.data;
}

export async function updateSquad(id, data) {
  const response = await api.put(`/admin/squads/${id}`, data);
  return response.data;
}

export async function deleteSquad(id) {
  await api.delete(`/admin/squads/${id}`);
}

// --- Practices ---

export async function getPractices() {
  const response = await api.get("/admin/practices");
  return response.data;
}

export async function createPractice(data) {
  const response = await api.post("/admin/practices", data);
  return response.data;
}

export async function updatePractice(id, data) {
  const response = await api.put(`/admin/practices/${id}`, data);
  return response.data;
}

export async function deletePractice(id) {
  await api.delete(`/admin/practices/${id}`);
}
